<div [uiTooltipTitle]="tooltipText" [uiTooltipTrigger]="tooltipText ? 'hover' : null" uiTooltipPlacement="left" ui-tooltip>
  <div class="cf-name" [attr.id]="fieldId" data-test-id="custom-field-name">{{ label }}<span *ngIf="required" aria-hidden="true">*</span></div>
</div>
